export default __webpack_public_path__ + "static/media/incoming-videocall.6f037c1e.mpeg";